import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {USER_TYPE} from 'containers/ManageUserPage/userType';
import {useData, useModal} from 'containers/ManageUserPage/hooks';
import {loadUsers} from 'containers/ManageUserPage/redux/thunks';
import {Navbar, Loading} from 'components';

import UserList from 'containers/ManageUserPage/UserList';
import AddUserModal from 'containers/ManageUserPage/AddUserModal';

import Teacher from 'assets/icons/coloured-teacher.svg';
import Learner from 'assets/icons/coloured-learner.svg';

import SubHeader from './SubHeader';

import {NUM_DASHBOARD} from './constants';

const navArr = [USER_TYPE.CONTENT_CREATOR, USER_TYPE.LEARNER].map(ele => ({
  ...ele,
  icon: ele.id === USER_TYPE.CONTENT_CREATOR.id ? Teacher : Learner,
}));

const initialUserType = navArr[0].id;

function User() {
  const [selectedNav, setSelectedNav] = useState(initialUserType);

  const {data, userType, loading} = useData();

  const {showModal, selectedUser, onShowModal, onClick} = useModal(data);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!userType) {
      dispatch(loadUsers(selectedNav));
    } else if (userType !== selectedNav) {
      setSelectedNav(userType);
    }
  }, [dispatch, userType, selectedNav]);

  const onSelect = (id: string) => () => {
    dispatch(loadUsers(id));
  };

  return (
    <>
      <SubHeader
        navigator={
          <Navbar active={selectedNav} onSelect={onSelect}>
            {navArr.map(nav => (
              <Navbar.Item data={nav} key={nav.id} />
            ))}
          </Navbar>
        }
        linkTo={`/${selectedNav}`}
        onClick={onClick()}
      />
      {loading && <Loading className="h-full-36" />}
      {!loading && (
        <UserList
          data={data}
          count={NUM_DASHBOARD}
          onClick={onClick}
          className="h-full-36"
        />
      )}
      <AddUserModal
        show={showModal}
        onClose={onShowModal}
        userType={selectedNav}
        selectedUser={selectedUser}
      />
    </>
  );
}

export default User;
